/* eslint-disable @typescript-eslint/no-explicit-any */
export interface BaseAPIErrorModel {
  type?: string | null | undefined
  title?: string | null | undefined
  status?: number | null | undefined
  traceId?: string | null | undefined
  errors?: any | null | undefined

  getAllErrorMessages(): string[]
}

export class BaseAPIErrorModel implements BaseAPIErrorModel {
  type?: string | null | undefined
  title?: string | null | undefined
  status?: number | null | undefined
  traceId?: string | null | undefined
  errors?: any | null | undefined

  constructor(error: BaseAPIErrorModel) {
    this.type = error?.type
    this.title = error?.title
    this.status = error?.status
    this.traceId = error?.traceId
    this.errors = error?.errors
  }

  public getAllErrorMessages(): string[] {
    const errorMessages: string[] = []

    if (typeof this.errors !== 'undefined') {
      if (Array.isArray(this.errors)) {
        for (let i = 0; i !== this.errors.length; i++) {
          errorMessages.push(this.errors[i])
        }
      } else if (typeof this.errors === 'object') {
        // ASP.NET ModelState shape: { field: ['message', ...], ... }. A plain object has no
        // `length`, so guarding on it skipped every field message and every ModelState 400
        // surfaced as zero messages. Read array-valued entries holding strings instead; that
        // also ignores the nested-node shape some endpoints return (childNodes/subKey/rawValue),
        // whose messages the serverErrors block below already handles.
        for (const k in this.errors) {
          const fieldErrors = this.errors[k]

          if (Array.isArray(fieldErrors)) {
            for (let i = 0; i !== fieldErrors.length; i++) {
              if (typeof fieldErrors[i] === 'string') {
                errorMessages.push(fieldErrors[i])
              }
            }
          }
        }

        // Array.isArray, not a `length` truthiness test: `errors.errors` is only iterable when
        // it really is an array. A string value (`{ errors: { errors: 'boom' } }`) has a length
        // too, and the old check walked it character by character. `?.errorMessage` covers null
        // entries — dereferencing one threw out of this method, and every caller invokes it
        // inside a submit handler, so the throw left the form stuck mid-submit with no message.
        if (Array.isArray(this.errors?.errors)) {
          const serverErrors = this.errors.errors as any[]

          for (let i = 0; i !== serverErrors.length; i++) {
            if (serverErrors[i]?.errorMessage) {
              errorMessages.push(serverErrors[i].errorMessage)
            }
          }
        }
      }
    } else {
      if (!errorMessages.includes('Oops..')) {
        errorMessages.push('Oops.. Something Went Wrong..')
      }
    }

    return errorMessages
  }
}
